import { memo } from "react";
import type { GridRowParams } from "@mui/x-data-grid";
import { MenuItem } from "consts/openBanking";
import { useBankingSDKRecipientsActions } from "features/openBanking/actions";
import { DeleteOpenBankingResource } from "../../shared/OpenBankingResource";

const DeleteBankingSDKRecipient = (props: GridRowParams) => {
    const { deleteBankingSdkRecipient } = useBankingSDKRecipientsActions();

    const deleteOpenBankingResource = async ({ row }: GridRowParams) => {
        const [request] = deleteBankingSdkRecipient(row, {
            shouldNotifyOnSuccess: true
        });
        await request;
    };

    return (
        <DeleteOpenBankingResource
            {...props}
            menuItem={MenuItem.BankingSDKRecipients}
            deleteOpenBankingResource={deleteOpenBankingResource}
            ModalProps={{
                titleSlot: `Delete ID=${props.row.coreId} Banking SDK Recipient`,
            }}
        >
            Are you sure you want to delete this Banking SDK Recipient?
        </DeleteOpenBankingResource>
    );
};

export default memo(DeleteBankingSDKRecipient);
